import(/* webpackMode: "eager", webpackExports: ["Loader"] */ "/builds/vivaldis/vivaldis_interim/frontend/src/components/atoms/Loader.tsx");
